import { render, staticRenderFns } from "./StTeaserOverviewEvents.vue?vue&type=template&id=b6da9b5e"
import script from "./StTeaserOverviewEvents.vue?vue&type=script&lang=ts"
export * from "./StTeaserOverviewEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports